/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function FundingWorksheetOtherDebt(id, name, value) {
    this.id = id;
    this.name = name;
    this.value = value;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheetOtherDebt.Blank = function () {
    return FundingWorksheetOtherDebt.Build({
      id: _.uuid(),
      name: '',
      value: 0
    });
  };
  FundingWorksheetOtherDebt.Build = function (data) {
    return new FundingWorksheetOtherDebt(
      data.id ? data.id : _.uuid(),
      data.name ? data.name : '',
      data.value ? data.value : 0
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  FundingWorksheetOtherDebt.prototype.getName = function () {
    return this.name;
  };

  return FundingWorksheetOtherDebt;
};
